import { FC, useMemo } from 'react'
import { CustomTable } from '../../../../../components/Table/CustomTable'
import { TableEmptyState } from '../../../../../components/Table/TableStates'
import { ProtocoloLinha } from '../../core/_models'
import { useVersoesProtocolo } from '../core/useVersoesProtocolo'
import { protocolosColumns } from './columns/_columns'

/** Demais versões do protocolo (a vigente fica em destaque acima da tabela). */
export const ProtocolosTriagemTable: FC = () => {
  const { demais, idEmpresa, acoes, isLoading, isError, refetch } = useVersoesProtocolo()

  const columns = useMemo(
    () => protocolosColumns({ idEmpresa, podeCriarRascunho: acoes.podeCriarRascunho }),
    [idEmpresa, acoes.podeCriarRascunho]
  )

  return (
    <CustomTable<ProtocoloLinha>
      id='kt_table_protocolos_triagem'
      ariaLabel='Versões do protocolo de triagem da empresa'
      itemLabel={{ singular: 'versão', plural: 'versões' }}
      data={demais}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={
        <TableEmptyState
          title='Nenhuma outra versão nesta empresa.'
          description='Rascunhos e versões substituídas aparecem aqui.'
        />
      }
      notPaginated
    />
  )
}
